// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gx_cfTjyKpyBqVi2upBA {
  display: flex;
  flex-direction: column;
  align-items: left;
  /* margin-top: 25px; */
}

.FTqO28HOjsS3nUGtocdA {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.5;
  text-align: left;
  padding: 25px 0;
}

.mbGF0jmJej2GHAAZSIwu {
  font-size: 20px;
  line-height: 1.5;
  padding-bottom: 25px;
}

.bOu5jSAJ7NkuBCL19GRl {
  align-self: flex-end;
}

.bOu5jSAJ7NkuBCL19GRl button {
  margin-left: 15px;
}

.VJG1rTcZRFyQOr4Hx9ou {
  align-self: center;
}

.UwhFqmxuJLgjb5mxUZp2 {
  cursor: pointer;
  color: #2fb5c7;
}
.UwhFqmxuJLgjb5mxUZp2:hover {
  color: #207d89;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":[".modalContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  /* margin-top: 25px; */\n}\n\n.modalText {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.5;\n  text-align: left;\n  padding: 25px 0;\n}\n\n.modalTextSecondary {\n  font-size: 20px;\n  line-height: 1.5;\n  padding-bottom: 25px;\n}\n\n.modalButtons {\n  align-self: flex-end;\n}\n\n.modalButtons button {\n  margin-left: 15px;\n}\n\n.modalButtonsCentered {\n  align-self: center;\n}\n\n.textLink {\n  cursor: pointer;\n  color: #2fb5c7;\n}\n.textLink:hover {\n  color: #207d89;\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `gx_cfTjyKpyBqVi2upBA`,
	"modalText": `FTqO28HOjsS3nUGtocdA`,
	"modalTextSecondary": `mbGF0jmJej2GHAAZSIwu`,
	"modalButtons": `bOu5jSAJ7NkuBCL19GRl`,
	"modalButtonsCentered": `VJG1rTcZRFyQOr4Hx9ou`,
	"textLink": `UwhFqmxuJLgjb5mxUZp2`
};
export default ___CSS_LOADER_EXPORT___;
